<div class="row">
  <div class="col-12">
    <div class="jitsi-meeting" allow="fullscreen" #jitsiContainer></div>
  </div>
</div>
